<template>
  <div id="catalogoJob" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container fluid class="base text-center ma-0 px-0 pt-6 pb-0">
      <v-row no-gutters class="titulo catalogoTitle"
        >Relación entre Áreas y Puestos de Trabajo</v-row
      >
      <v-row class="catalogo catalogoList">
        <v-col cols="12" sm="8" class="py-2">Selecciona la Empresa</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="estructura" id="estructura" v-model="estructura">
            <option disabled value="0">Selecciona estructura</option>
            <option
              v-for="carga in structure"
              :key="carga.id"
              v-bind:value="carga.id"
            >
              {{ carga.nombre }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2" v-if="estructura == 2"
          >Empresa Pagadora</v-col
        >
        <v-col cols="12" sm="4" class="py-2 selectGris" v-if="estructura == 2">
          <select name="pagadora" id="pagadora" v-model="enterprise">
            <option disabled value="0">Selecciona empresa</option>
            <option
              v-for="enterprise in enterprises"
              :key="enterprise.id"
              v-bind:value="enterprise.id"
            >
              {{ enterprise.razonSocial }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-1">
          <p style="font-size: 18px">
            <i style="color: #0f6c21" class="fas fa-file-excel"></i>
            <a href="#" @click="descargaExcel()">&nbsp;&nbsp;Descargar</a>
            plantilla de excel para llenar.
          </p>
        </v-col>

        <v-col cols="12" sm="12" class="uploadfile p-0 pb-0 pt-2">
          Subir archivo Excel con la relación de areás-puestos
          <input
            type="file"
            id="archivo"
            class="pb-2"
            lang="es"
            ref="fileUploadPerfilEdit"
            @click="resetFile"
            @change="previewFiles($event)"
          />
        </v-col>
        <br />
        <v-col cols="12" sm="12" class="mt-3 pa-0" align-self="end">
          <button class="boton" @click="validacion()">Guardar</button>
          <router-link to="/connection">
            <button class="boton">Regresar</button>
          </router-link>
        </v-col>
      </v-row>
      <v-col></v-col>
    </v-container>
    <!--Error-->
    <v-dialog v-model="error" width="380">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">{{ titulo }}</span>
        </v-card-title>
        <v-card-text>
          <h3 class="text-md-center text-sm-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
          <ul style>
            <li v-for="error in errors" :key="error.name">{{ error }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="error = false">Corregir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Validación de datos-->
    <v-dialog v-model="advice" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-lg-center text-sm-center">
            ¿Esta seguro de almacenar la relacion de puestos con las áreas
            asignadas?
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="red"
            text
            @click="
              cancel();
              advice = false;
            "
            >Cancelar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="procesarExcel()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Relación</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-sm-center text-md-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="aux()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      stepn: "5-N",
      error: false,
      show: false,
      advice: false,
      confirmation: false,
      errors: [],
      estructura: 2,
      structure: [
        {
          id: 1,
          nombre: "Empresa Comercial",
        },
        {
          id: 2,
          nombre: "Empresa Pagadora",
        },
      ],
      respuesta: "",
      titulo: "",
      nivel: 0,
      carga: 0,
      enterprises: [],
      enterprise: 0,
      posicion: 0,
      nombreArchivo: "",
      selectedFile: "",
    };
  },
  methods: {
    nombre() {
      localStorage.stepn = this.stepn;
    },
    validacion() {
      this.errors = [];
      if (this.estructura == 0) {
        this.errors.push("Debe especificar la estructura organizacional");
      }
      if (this.enterprise == 0) {
        this.errors.push("Debe especificar la empresa pagadora");
      }
      if (this.errors.length == 0) {
        if (this.estructura == 1) {
          this.enterprise = localStorage.idCommercialEnterprise;
          this.advice = true;
        } else this.advice = true;
      } else {
        this.titulo = "Relación area-puesto";
        this.error = true;
      }
    },
    regresar() {
      this.enterprise = 0;
      this.stepn = "14-N";
      this.nombre();
    },
    descargaExcel() {
      this.show = true;
      if (this.enterprise != 0) {
        this.show = true;
        axios(
          {
            url: Server + "/puestos/plantilla-puestos-areas/" + this.enterprise,
            method: "GET",
            responseType: "blob",
          },
          { useCredentails: true }
        ) // CORS
          .then((response) => {
            this.show = false;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            var fecha = new Date();
            link.setAttribute(
              "download",
              "Puestos" + fecha.getTime() + ".xlsx"
            );
            document.body.appendChild(link);
            link.click();
          })
          .catch((e) => {
            this.show = false;
          });
      } else {
        this.titulo = "Solicitud de Archivo fallida";
        this.errors.push("Por favor selecciona la empresa Pagadora");
        this.error = true;
      }
    },
    resetFile() {
      this.$refs.fileUploadPerfilEdit.value = "";
    },
    procesarExcel: function () {
      this.advice = false;
      var data = new FormData();
      data.append("idEmpresa", this.enterprise);
      data.append("excel", this.selectedFile, this.selectedFile.name);
      this.show = true;
      axios
        //.post(Server + "/puestos/cargar/excel", data, {
        .post(Server + "/puestos/cargar/excel-puestos-areas", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.respuesta = "La relación fue guardada con éxito";
          this.show = false;
          this.confirmation = true;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          this.respuesta = "La relación no fue guardada.";
          this.confirmation = true;
        });
    },
    previewFiles(event) {
      this.errors = [];
      console.log(event);
      this.nombreArchivo = event.target.files[0].name;
      this.nombreArchivo.toLowerCase();
      var regex = new RegExp("(.*?).(xlsx|xls)$");
      if (!regex.test(this.nombreArchivo)) {
        this.nombreArchivo = "";
        this.titulo = "Archivo inválido";
        this.errors.push(
          "No se permite el archivo que ingreso favor de ingresar archivo con layout predeterminado."
        );
        this.error = true;
      } else {
        this.selectedFile = event.target.files[0];
        console.log("listo", this.selectedFile);
      }
    },
    listar() {
      this.show = true;
      axios
        .get(Server + "/empresas")
        .then((response) => {
          this.enterprises = response.data;
          this.show = false;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
    cancel() {
      this.enterprise = 0;
      this.job = "";
      this.key = "";
      this.jobr = 0;
      this.area = 0;
      this.posicion = 0;
    },
    aux() {
      this.confirmation = false;
      this.$router.push("/connection");
    },
  },
  created() {
    this.nombre();
    this.listar();
  },
};
</script>